import { Link } from '@/components/LocalizedLink';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import SEOHead from '@/components/SEOHead';

const NotFound = () => {
  const location = useLocation();
  const { lang } = useLanguage();

  useEffect(() => {
    // A 404 is an expected navigation outcome, not an application error — only
    // surfaced in dev so it doesn't trip Lighthouse's "no console errors" check
    // or clutter the console for real visitors in production.
    if (import.meta.env.DEV) {
      console.warn('404: no route matches', location.pathname);
    }
  }, [location.pathname]);

  const links = lang === 'tr'
    ? [
        { to: '/', label: 'Ana sayfa' },
        { to: '/services', label: 'Hizmetler' },
        { to: '/projects', label: 'Projeler' },
        { to: '/blog', label: 'Blog' },
        { to: '/contact', label: 'İletişim' },
      ]
    : [
        { to: '/', label: 'Home' },
        { to: '/services', label: 'Services' },
        { to: '/projects', label: 'Projects' },
        { to: '/blog', label: 'Blog' },
        { to: '/contact', label: 'Contact' },
      ];

  return (
    <main className="flex min-h-screen items-center justify-center bg-background pt-16">
      <SEOHead
        title={lang === 'tr' ? 'Sayfa bulunamadı' : 'Page not found'}
        description={lang === 'tr' ? 'Aradığınız sayfa mevcut değil.' : 'The page you requested does not exist.'}
        canonical={location.pathname}
        noindex
      />
      <div className="text-center px-6 max-w-lg">
        <p className="font-display text-6xl font-bold text-foreground mb-4" aria-hidden="true">404</p>
        <h1 className="mb-3 text-xl text-foreground">
          {lang === 'tr' ? 'Sayfa bulunamadı' : 'Page not found'}
        </h1>
        <p className="mb-10 text-muted-foreground">
          {lang === 'tr'
            ? 'Bu sayfa taşınmış veya kaldırılmış olabilir. Aşağıdaki bağlantılardan devam edebilirsiniz.'
            : 'This page may have moved or been removed. You can continue from the links below.'}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          {links.map((link, i) => (
            <Link
              key={link.to}
              to={link.to}
              className={
                i === 0
                  ? 'font-body text-sm px-6 py-3 bg-foreground text-background rounded-full font-medium hover:opacity-90 transition-opacity'
                  : 'font-body text-sm px-6 py-3 border border-border rounded-full text-foreground hover:border-foreground/40 transition-colors'
              }
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
};

export default NotFound;
